import { QIExpand, QICustomDateRangePicker, QITable, QISpinner } from "../../../components";
import { PaginationFooter, NoData } from "../../Shared";
import { FMDPStorage } from "../../../shared/helper";
import moment from "moment";
import "./mapViewFlyOut.scss";
import { useState, useEffect } from "react";
import { getLocalizedString } from "../../../shared/translation";

export const MapViewFlyOut = ({
  data,
  listType,
  setMapExpand,
  simpleSearch,
  setSimpleSearch,
  disableSimpleSearch,
  advanceSearch,
  setAdvanceSearch,
  isSuccess = true,
  isLoading,
  selectedPage,
  pagination,
  children,
  search_by_message = "",
  title,
  getHeaderList = () => {},
  setSortedDataDisplay,
  sortedDataDisplay,
  setPage,
  setPageVehicles,
  isRefreshing,
  deviceId,
  isLiveFeedCount,
  isLiveFeed,
  setDeviceId = () => {},
  setDetails = () => {},
  setDockAlign = () => {},
  setSelectedRowId = () => {},
  AdvanceSearchComponent,
  advanceSearchProps,
  selectedPlateNumbers = [],
  onClearFilter,
  onClearAllFilters,
  isAutoRefreshPaused,
}) => {
  const isAlternativeUI = FMDPStorage?.get("current-user")?.layout === "Default" ? false : true;
  const [lastUpdateTime, setLastUpdateTime] = useState(moment().format("HH:mm:ss"));

  // Update last update time when refresh happens
  useEffect(() => {
    if (isRefreshing) {
      setLastUpdateTime(moment().format("HH:mm:ss"));
    }
  }, [isRefreshing]);

  // Only show auto-refresh for active vehicles view
  const showAutoRefresh =
    (selectedPage === "Vehicles" || selectedPage === "Devices") && sortedDataDisplay;

  // Check if we should show pause icon
  const showPauseIcon = isAutoRefreshPaused ?? Boolean(deviceId || simpleSearch || advanceSearch);

  const renderContent = () => (
    <>
      {/* {selectedPage !== "Vehicles" && (
        <QICustomDateRangePicker
          resetCount={resetCount}
          selectedRange={selectedRange}
          setSelectedRange={setSelectedRange}
          setResetCount={setResetCount}
        />
      )} */}
      {isLoading && (
        <div className="no-data">
          <QISpinner size="50px" />
        </div>
      )}

      {/* Display info bar with auto-refresh status and count */}
      {data?.length > 0 && (
        <div className="info-bar-container">
          {showAutoRefresh ? (
            <div className={`last-refresh-info ${isRefreshing ? "refreshing" : ""}`}>
              <div className="refresh-info-content">
                <span className="refresh-status">{isRefreshing ? getLocalizedString("refreshing", "Refreshing...") : ""}</span>
                <span className="refresh-time">{getLocalizedString("last_updated", "Last Updated")}: {lastUpdateTime}</span>
              </div>
              {showPauseIcon ? (
                <div className="pause-indicator">
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                    <rect x="6" y="4" width="4" height="16" rx="1" />
                    <rect x="14" y="4" width="4" height="16" rx="1" />
                  </svg>
                </div>
              ) : (
                <span className="refreshing-indicator pulsating">●</span>
              )}
            </div>
          ) : (
            selectedPage !== "Events" && <div className="auto-refresh-spacer"></div>
          )}

          {selectedPage === "Events" && (
            <div
              className={`last-refresh-info ${
                pagination?.page === 1 &&
                deviceId === null &&
                !simpleSearch &&
                !advanceSearch &&
                isLiveFeed
                  ? "live-active"
                  : "live-paused"
              }`}
            >
              <div className="refresh-info-content">
                <span className="refresh-status">
                  {pagination?.page === 1 &&
                  deviceId === null &&
                  !simpleSearch &&
                  !advanceSearch &&
                  isLiveFeed
                    ? getLocalizedString("live_feed", "Live Feed")
                    : getLocalizedString("live_feed_paused", "Live Feed Paused")}
                </span>
              </div>
              {pagination?.page === 1 &&
              deviceId === null &&
              !simpleSearch &&
              !advanceSearch &&
              isLiveFeed ? (
                <span className="refreshing-indicator pulsating">●</span>
              ) : (
                <div className="pause-indicator">
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                    <rect x="6" y="4" width="4" height="16" rx="1" />
                    <rect x="14" y="4" width="4" height="16" rx="1" />
                  </svg>
                </div>
              )}
            </div>
          )}

          {pagination?.count > 0 && (
            <div className="pagination-count-display">
              <span className="total-count-label">{getLocalizedString("total", "Total")}:</span>
              <span className="total-count-value">
                {selectedPage === "Events" ? pagination.count + isLiveFeedCount : pagination.count}
              </span>
              <span className="total-count-suffix">
                {pagination.count === 1
                  ? getLocalizedString(selectedPage === "Vehicles" ? "vehicle" : "device", selectedPage === "Vehicles" ? "vehicle" : "device")
                  : title}
              </span>
            </div>
          )}
        </div>
      )}

      {data?.length > 0 && getHeaderList()}
      {data?.length > 0 ? (
        <ul
          className={`${listType.toLowerCase()}-list card-view-list asset-list ${
            advanceSearch != null ? "search-filters-added" : ""
          }`}
        >
          {children}
        </ul>
      ) : (
        !isLoading && <NoData />
      )}
      {/* Show pagination for both tabs */}
      {data?.length > 0 && isSuccess && pagination && <PaginationFooter pagination={pagination} />}
    </>
  );

  return (
    <>
      <QIExpand
        simpleSearch={simpleSearch}
        setSimpleSearch={setSimpleSearch}
        simpleSearchPlaceholder={search_by_message}
        disableSimpleSearch={disableSimpleSearch}
        setMapExpand={setMapExpand}
        title={title}
        alternativeUI={isAlternativeUI}
        setDeviceId={setDeviceId}
        setDetails={setDetails}
        setDockAlign={setDockAlign}
        setSelectedRowId={setSelectedRowId}
        advanceSearch={advanceSearch}
        setAdvanceSearch={setAdvanceSearch}
        selectedPage={selectedPage}
        AdvanceSearchComponent={AdvanceSearchComponent}
        advanceSearchProps={advanceSearchProps}
        selectedPlateNumbers={selectedPlateNumbers}
        onClearFilter={onClearFilter}
        onClearAllFilters={onClearAllFilters}
        subNavigation={
          selectedPage === "Vehicles" && (
            <nav className="main-container_header_link">
              <a
                className={`main-container_header_link_item ${sortedDataDisplay ? "" : "active"}`}
                onClick={() => {
                  setSortedDataDisplay(false);
                  setPage(1);
                }}
              >
                All
              </a>
              <a
                className={`main-container_header_link_item ${sortedDataDisplay ? "active" : ""}`}
                onClick={() => {
                  setSortedDataDisplay(true);
                  setPageVehicles(1);
                }}
              >
                Active
              </a>
            </nav>
          )
        }
      >
        {renderContent()}
      </QIExpand>
    </>
  );
};
